module.exports = __webpack_public_path__ + "static/media/and_icon_touch_id.7e782f1b.png";